import { GET_PLC_SAFETY_ZONES, GET_PLC_SAFETY_ZONES_SUCCESS, GET_PLC_SAFETY_ZONES_ERROR } from './actionTypes';

const initialState = {
  errorGetPlcSafetyZones: '',
  loadingGetPlcSafetyZones: false,
  zones: null,
};

const getZones = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_ZONES:
      state = { ...state, loadingGetPlcSafetyZones: true };
      break;
    case GET_PLC_SAFETY_ZONES_SUCCESS:
      state = { ...state, loadingGetPlcSafetyZones: false, zones: action.payload.zones };
      break;
    case GET_PLC_SAFETY_ZONES_ERROR:
      state = { ...state, errorGetPlcSafetyZones: action.payload, loadingGetPlcSafetyZones: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getZones;
